<div class="flex flex-col h-full">
  @if (isLoading()) {
    <div class="sticky top-0 left-0 right-0 z-[200]">
      <div class="w-full absolute">
        <mat-progress-bar class="mds-x-small" [mode]="'indeterminate'"></mat-progress-bar>
      </div>
    </div>
  }

  <div class="flex flex-row items-center py-2 pl-3 text-xl font-medium border-b border-gray-1">
    {{ translations.title.text }}
    <div class="flex flex-1 justify-end mr-2">
      <button
        id="3d-global-settings-close"
        class="text-gray-8"
        modus-icon-button
        (click)="exitSettingsClick.emit()"
      >
        <md-icon>close</md-icon>
      </button>
    </div>
  </div>

  @if (scan3dStyle(); as style) {
    <div class="h-full overflow-y-auto p-4">
      <sd-scan-3d-styling
        class="h-full"
        [elevationPicking]="elevationPicking()"
        [scan3dStyle]="style"
        [scan3dStyleUom]="scan3dStyleUom()"
        (styleChange)="onStyleChange($event)"
        (elevationPickingChange)="onElevationPickingChange($event)"
      ></sd-scan-3d-styling>
    </div>
  }
</div>
